import React from 'react';
import GlobalStyles from '../../styles/GlobalStyles';
import Header from './Header';
import BottomNav from './BottomNav';
import { theme } from '../../styles/theme';

const Layout: React.FC = ({ children }) => {
    return (
        <div style={{ fontFamily: theme.fonts.primary, margin: 0, padding: 0, background: theme.colors.bgPrimary, minHeight: '100vh' }}>
            <GlobalStyles />
            <Header />
            <main className="container" style={{ paddingBottom: '84px' }}>{children}</main>
            <BottomNav />
        </div>
    );
};

export default Layout;
